import React, { useEffect } from "react";
import OfferstatsVenderResponsive from "./OfferstatsVenderResponsive";
import OfferVoucherissuedRedeemed from "./OfferVoucherissuedRedeemed";
import OfferVoucherIssuedData from "./OfferVoucherIssuedData";
import OfferViewData from "./OfferViewData";
import { offerStatsTAB } from "../../Redux/Slice/Offer";
import { useDispatch, useSelector } from "react-redux";

const OfferViewStats = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(offerStatsTAB("view"));
  }, []);
  return (
    <>
      <section className="offerstatsinnerPage">
        <div className="cust_container">
          <OfferstatsVenderResponsive />
          <OfferViewData />
        </div>
      </section>
    </>
  );
};

export default OfferViewStats;
